import { z } from 'zod';

export const federalStateSchema = z.object({
  idFederalState: z.number(),
  FederalState: z.string(),
  landRegisterNeedLoginFirstInstance: z.boolean(),
  landRegisterUser: z.string(),
  landRegisterPassword: z.string(),
  landRegisterUrl: z.string(),
  landRegisterSIData: z.boolean(),
});

export type IFederalState = z.infer<typeof federalStateSchema>;

export const courtSchema = z.object({
  idCourt: z.number(),
  Court: z.string(),
  idFederalState: z.number(),
  FederalState: z.string(),
  XJustizID: z.string().optional(),
  activeCourt: z.boolean().optional(),
  PhoneNumber: z.string(),
  Website: z.string(),
  Street: z.string(),
  StreetNr: z.string(),
  StreetAditional: z.string(),
  idPostcode: z.number().nullable(),
  Email: z.string(),
  Postcode: z.string().optional(),
  City: z.string().optional(),
});

export type ICourt = z.infer<typeof courtSchema>;

export interface IAdminstrativeUnit {
  idAdministrativeUnit: number;
  AdministrativeUnit: string;
  idFederalState: number;
  FederalState: string;
  activeUnit?: boolean;
}

export interface ICourtRole {
  idCourtRole: number;
  CourtRole: string;
  activeRole?: boolean;
}

export interface ICourtAdminstrativeUnitAssignment {
  idCourt: number;
  Court: string;
  idAdministrativeUnit: number;
  AdministrativeUnit: string;
  idCourtRole: number;
  CourtRole: string;
  idFederalState: number;
  FederalState: string;
  idAssignment: number;
  activeAssignment?: boolean;
}

export interface ICourtCourtRole {
  idCourt: number;
  Court: string;
  idCourtRole: number;
  CourtRole: string;
  idFederalState: number;
  currentProcessingTime: number;
  initalProcessingTime: number;
  activeCourtCourtRole?: boolean;
}
